export const INSCRIPTIONETB__CREATE_RESET = "INSCRIPTIONETB__CREATE_RESET";
export const INSCRIPTIONETB__CREATE_SET_CREATED =
  "INSCRIPTIONETB__CREATE_SET_CREATED";
export const INSCRIPTIONETB__CREATE_SET_ERROR =
  "INSCRIPTIONETB__CREATE_SET_ERROR";
export const INSCRIPTIONETB__CREATE_SET_VIOLATIONS =
  "INSCRIPTIONETB__CREATE_SET_VIOLATIONS";
export const INSCRIPTIONETB__CREATE_TOGGLE_LOADING =
  "INSCRIPTIONETB__CREATE_TOGGLE_LOADING";
